export interface ProfileData {
  avatar: string | null;
  created_at: string;
  email: string;
  full_name: string;
  id: string;
  partner_carehome_id: string;
  role: string;
  status: string;
  title: string | null;
  updated_at: string;
}

export interface PartnerCarehome {
  created_at: string;
  id: string;
  image: string;
  name: string;
  status: string;
  type: string;
  updated_at: string;
  totalResidents: number;
}
export interface PartnerCarehomeData {
  carehome_partner_id: string;
  carehome_staff_id: string;
  created_at: string;
  id: string;
  partner_carehome: PartnerCarehome;
  updated_at: string;
}

export enum Role {
  Manager = 'manager',
  TeamMember = 'teamMember',
  TeamMemberViewOnly = 'teamMemberViewOnly',
}

export const roles = [
  { id: 1, value: Role.Manager, label: 'Manager' },
  { id: 2, value: Role.TeamMember, label: 'Team Member' },
  { id: 3, value: Role.TeamMemberViewOnly, label: 'Team Member (View Only)' },
];
